var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_290",
    "data-name": "Group 290",
    transform: "translate(-987 -154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_285",
    "data-name": "Group 285",
    transform: "translate(-108 -814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_70",
    d: "M0 0H56V56H0z",
    "data-name": "Rectangle 70",
    transform: "translate(1095 968)",
    style: {
      fill: "#00ff6f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_287",
    "data-name": "Group 287",
    transform: "translate(12674 17235.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_291",
    "data-name": "Group 291",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_81",
    "data-name": "Rectangle 81",
    transform: "translate(-11672 -17061.318)",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 17,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 15,
    x: 1,
    y: 1,
    rx: 1,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_108",
    d: "M-11548.5-17009h24.582",
    "data-name": "Path 108",
    transform: "translate(-121.782 -46.536)",
    style: {
      strokeWidth: 3,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_112",
    d: "M-11548.5-17009h2.875",
    "data-name": "Path 112",
    transform: "translate(-119.95 -39.536)",
    style: {
      stroke: "#fff",
      fill: "none"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/payment-active.c9b824f6f2f867577b2bdcdbbfa81385.svg";
export { ForwardRef as ReactComponent };